<script setup lang="ts">
type Props = {
  showWithdrawRules: boolean;
};

const { showWithdrawRules } = defineProps<Props>();

type Emits = {
  'toggle-withdraw-rules': [];
};

const emit = defineEmits<Emits>();

const { closeModal } = useLayoutStore();

const clickToCloseModal = () => {
  closeModal();
};
</script>

<template>
  <div :class="$style.titleContainer">
    <NuxtIcon
      v-if="showWithdrawRules"
      :class="$style.backIcon"
      name="arrows/arrow_left"
      @click="emit('toggle-withdraw-rules')"
    />
    <NuxtIcon
      v-else
      :class="$style.backIcon"
      name="arrows/arrow_left"
      @click="clickToCloseModal"
    />

    <div
      v-if="showWithdrawRules"
      :class="$style.textSection"
    >
      <span :class="$style.title">
        {{ $t('account.wallet.withdraw_modal.withdraw_rules') }}
      </span>
      <span :class="$style.subtitle">
        {{ $t('account.wallet.withdraw_modal.withdraw_rules_subtitle') }}
      </span>
    </div>

    <div
      v-else
      :class="$style.textSection"
    >
      <span :class="$style.title">
        {{ $t('account.wallet.withdraw_modal.title') }}
      </span>
      <span :class="$style.subtitle">
        {{ $t('account.wallet.withdraw_modal.subtitle') }}
      </span>
    </div>

    <WithdrawRulesButton
      :class="[`ml-auto`, 'mr-0']"
      :is-rounded="true"
      :show-icon="true"
      :show-text="false"
      @toggle-withdraw-rules="emit('toggle-withdraw-rules')"
    />
  </div>
</template>

<style module lang="postcss">
.titleContainer {
  @apply flex flex-row items-center gap-4;

  .backIcon {
    @apply text-auth-texts/80 cursor-pointer;
  }

  .textSection {
    @apply flex flex-col;

    .title {
      @apply text-auth-texts font-bold text-base text-left;
    }

    .subtitle {
      @apply text-auth-texts/70 font-normal text-xs text-left;
    }
  }
}
</style>
